let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7ioy0")).then(() => parcelRequire('gMkb6'));